var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.1667V0.5C0 0.223858 0.223858 0 0.5 0C0.776142 0 1 0.223858 1 0.5V11.1667C1 11.3877 1.08786 11.5996 1.24414 11.7559C1.40042 11.9121 1.61232 12 1.83333 12H12.5C12.7761 12 13 12.2239 13 12.5C13 12.7761 12.7761 13 12.5 13H1.83333C1.3471 13 0.880926 12.8067 0.537109 12.4629C0.193293 12.1191 0 11.6529 0 11.1667Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.5C10.6667 2.40795 10.592 2.33333 10.5 2.33333H9.16667C9.07462 2.33333 9 2.40795 9 2.5V9.16667C9 9.25871 9.07462 9.33333 9.16667 9.33333H10.5C10.592 9.33333 10.6667 9.25871 10.6667 9.16667V2.5ZM11.6667 9.16667C11.6667 9.811 11.1443 10.3333 10.5 10.3333H9.16667C8.52233 10.3333 8 9.811 8 9.16667V2.5C8 1.85567 8.52233 1.33333 9.16667 1.33333H10.5C11.1443 1.33333 11.6667 1.85567 11.6667 2.5V9.16667Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 4.5C5.33333 4.40795 5.25871 4.33333 5.16667 4.33333H3.83333C3.74129 4.33333 3.66667 4.40795 3.66667 4.5V9.16667C3.66667 9.25871 3.74129 9.33333 3.83333 9.33333H5.16667C5.25871 9.33333 5.33333 9.25871 5.33333 9.16667V4.5ZM6.33333 9.16667C6.33333 9.811 5.811 10.3333 5.16667 10.3333H3.83333C3.189 10.3333 2.66667 9.811 2.66667 9.16667V4.5C2.66667 3.85567 3.189 3.33333 3.83333 3.33333H5.16667C5.811 3.33333 6.33333 3.85567 6.33333 4.5V9.16667Z",
    fill: "#0A0A0A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnChart);
export default __webpack_public_path__ + "static/media/btn-chart.57b1d19a1ceb6403f6c33c0cf34fa9b6.svg";
export { ForwardRef as ReactComponent };